import { fetchWithAuth } from '@/lib/api-client';

export interface Alert {
  id: number;
  tenantId: string;
  factoryId: string;
  alertType: string;
  severity: string;
  assetId: string | null;
  assetName?: string;
  zoneId: string | null;
  zoneName?: string;
  message: string;
  triggeredAt: string;
  resolvedAt: string | null;
  isResolved: boolean;
  metadata: Record<string, unknown>;
  createdAt: string;
}

export interface AlertFilters {
  type?: string;
  assetId?: string;
  zoneId?: string;
  from?: string;
  to?: string;
  limit?: number;
  resolved?: boolean;
}

export interface AlertsResponse {
  alerts: Alert[];
}

export async function getAlerts(
  factoryId: string,
  filters?: AlertFilters
): Promise<AlertsResponse> {
  const query = new URLSearchParams();
  if (filters?.type) {
    query.set('type', filters.type);
  }
  if (filters?.assetId) {
    query.set('assetId', filters.assetId);
  }
  if (filters?.zoneId) {
    query.set('zoneId', filters.zoneId);
  }
  if (filters?.from) {
    query.set('from', filters.from);
  }
  if (filters?.to) {
    query.set('to', filters.to);
  }
  if (filters?.limit !== undefined) {
    query.set('limit', String(filters.limit));
  }
  if (filters?.resolved !== undefined) {
    query.set('resolved', String(filters.resolved));
  }

  const qs = query.toString();
  return fetchWithAuth<AlertsResponse>(`/api/factories/${factoryId}/alerts${qs ? `?${qs}` : ''}`);
}

export interface AlertSummary {
  total: number;
  active: number;
  byType: { zone_entry: number; zone_exit: number; zone_dwell: number };
  bySeverity: { error: number; warning: number; info: number };
}

export async function getAlertSummary(factoryId: string): Promise<AlertSummary> {
  const response = await fetchWithAuth<{ summary: AlertSummary }>(
    `/api/factories/${factoryId}/alerts/summary`
  );
  return response.summary;
}

export async function resolveAlert(factoryId: string, alertId: number): Promise<{ alert: Alert }> {
  return fetchWithAuth<{ alert: Alert }>(`/api/factories/${factoryId}/alerts/${alertId}/resolve`, {
    method: 'PATCH',
  });
}
